import { Breadcrumb, Card, Col, Icon, Popconfirm, Row, Tabs, Tooltip } from 'antd'
import AddRatingSystemCont from 'components/Main/RatingSystem/AddRating/AddRatingSystemCont'
import AddQuestionnaireSystemCont from '../../../components/Main/QuestionnaireSystem/AddRating/AddQuestionnaireSystemCont'
import { DeliveryOrderApi } from '../../../api/Purchase/DeliveryOrder'
import Documents from '../../../components/Common/Documents/DocumentsCont'
import EmailCont from '../../../components/Common/Email/EmailCont'
import History from '../../../components/Common/History'
import DeliveryOrderList from '../../../components/Purchasing/DeliveryOrder/DeliveryOrderList'
import FeeCont from '../../../components/Purchasing/Order/Fee/FeeCont'
import GenerateDocument from '../../../components/Purchasing/Order/GenerateDocument/GenerateDocument'
import PackingCont from '../../../components/Purchasing/Order/PackingList/PackingCont'
import PaymentPlanCont from '../../../components/Purchasing/Order/PaymentsPlan/PaymentPlanCont'
import ReadyToOrderForm from '../../../components/Purchasing/Order/ReadyToOrderForm'
import ReadyToOrderFreightForm from '../../../components/Purchasing/Order/ReadyToOrderFreightForm'
import RemittanceList from '../../../components/Purchasing/Remittance/List'
import PaymentTermsCont from '../../../components/Purchasing/VendorQuotes/PaymentsTerms/PaymentTermsCont'
import VouchersCont from '../../../components/Purchasing/Voucher/VouchersCont'
import style from '../../../components/Sales/style.css'
import AmountDetails from '../../../elements/AmountDetails'
import FooterButtons from '../../../elements/Buttons/FooterButtons'
import RefreshButton from '../../../elements/Buttons/RefreshButton'
import CustomSpin from '../../../elements/CustomSpin'
import useFetchList from '../../../elements/Hooks/useFetchList'
import useFetchURL from '../../../elements/Hooks/useFetchURL'
import IconText from '../../../elements/IconText'
import Status from '../../../elements/Status'
import { capitalize, get, isEmpty } from 'lodash'
import Authentication from '../../../modules/Authentication'
import { idMaker, strVal } from '../../../modules/Utils'
import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import { streamUrl } from '../../../variables'
import EmailListCont from '../../Main/Emails/EmailCont'

const auth = new Authentication()
const ids = idMaker()
const { TabPane } = Tabs

function UpdateOrder(props) {
  const {
    order,
    lines,
    actions,
    handleActions,
    massCollect,
    fetchingActions,
    onShowEmail,
    visibleEmail,
    onCancelEmail,
    emailTemplate,
    emailDetails,
    emailFiles,
    emailLines,
    updating,
    update,
    formRef,
    fetching,
    isUpdatable,
    removing,
    remove,
    isNew,
    fetch,
    onShowReadyToCollect,
  } = props

  const type = get(order, 'category')
  const isFreight = ['Freight', 'Clearance'].includes(type)

  const isConfirmed = ['Confirmed', 'Approved'].includes(order.status)
  const Operations = ({ order, ...rest }) => {
    const ops = actions
      .filter((a) => a.key !== 'update' && a.key !== 'remove')
      .map((a) => (
        <span>
          <Popconfirm
            placement="left"
            title={
              a.key === 'approve' && isFreight
                ? `Have you checked the weights & dimensions of the packages and cargo?`
                : `Are you sure to ${a.value}?`
            }
            onConfirm={() => handleActions(a.key)}
            okText="Yes"
            cancelText="No">
            <a>{a.value}</a>
          </Popconfirm>
        </span>
      ))

    if (ops.length > 0 && !isConfirmed) {
      ops.push(
        <a target={'_blank'} href={`${streamUrl}pdf/${get(order, '_id')}?access_token=${auth.getAccessToken()}`}>
          <IconText text={'PDF preview'} type={'file-pdf'} />
        </a>
      )
    }
    if (ops.length > 0 && isConfirmed) {
      ops.push(
        <a onClick={onShowEmail}>
          <IconText text={'Send Email'} type={'mail'} />
        </a>
      )
    }

    if (ops.length > 0 && isConfirmed && strVal(order, 'type') !== 'Freight Booking') {
      ops.push(
        <Popconfirm placement="left" title={`Are you sure !`} onConfirm={massCollect} okText="Yes" cancelText="No">
          <a>
            <IconText text={'Mass Ready To Collect'} type={'mail'} />
          </a>
        </Popconfirm>
      )
    }

    return (
      <div {...rest}>
        {ops.length > 0 ? ops.reduce((prev, curr) => [prev, <span className="ant-divider" />, curr]) : []}
      </div>
    )
  }

  const { list: listDelivery, fetching: fetchingDelivery, fetch: fetchDelivery } = useFetchList(
    () => DeliveryOrderApi.list('*', `purchases=${order._key}`),
    [order._key],
    isEmpty(order._key)
  )

  const { data: listRemittance, fetching: fetchingRemittance, fetchURL: fetchRemittance } = useFetchURL(
    `foxxapi/remittances/purchases/${order._key}`,
    [order._key],
    isEmpty(order._key)
  )

  const SubmitButton = () => (
    <FooterButtons
      style={{ marginBottom: 10 }}
      remove={remove}
      removing={removing}
      update={update}
      submitting={updating}
      title={'Order'}
      isNew={false}
      isEdit={true}
      isRemovable={['Submitted', 'Draft'].includes(order.status)}
    />
  )
  return (
    <CustomSpin spinning={fetchingActions || fetching}>
      <Card>
        <Row className={style.pageHeader}>
          <Breadcrumb>
            <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
            <Breadcrumb.Item>Purchasing</Breadcrumb.Item>
            <Breadcrumb.Item href={`#/purchasing/order`}>Order</Breadcrumb.Item>
            <Breadcrumb.Item>{order.code}</Breadcrumb.Item>
          </Breadcrumb>

          <Fragment>
            <Col span={17}>
              <h3 className={style.title}>
                <h2 className={'icon-text-header'}>
                  <Icon
                    type="barcode"
                    style={{
                      marginRight: '5px',
                      color: '#08c',
                    }}
                  />
                  <Tooltip title="Order Code">{strVal(order, 'code')}</Tooltip>
                </h2>
                <Status value={capitalize(strVal(order, 'status'))} />
                <Operations style={{ marginTop: '10px' }} order={order} status={strVal(order, 'status')} />
                <br />

                <Tooltip title="Order Type">{strVal(order, 'type')}</Tooltip>
              </h3>
              {strVal(order, 'type') === 'Freight Booking' && (
                <GenerateDocument isUpdatable={isConfirmed} owner={order._id} />
              )}
            </Col>
            <Col span={5}>
              <AmountDetails doc={order} />
            </Col>
            <RefreshButton onClick={fetch} />
          </Fragment>
        </Row>
      </Card>
      <EmailCont
        key={ids.next().value}
        visible={visibleEmail}
        onCancel={onCancelEmail}
        template={emailTemplate}
        email={emailDetails}
        files={emailFiles}
        lines={emailLines}
      />
      <Card className={style.contentCard}>
        <Tabs defaultActiveKey={get(props, 'location.hash') || '#details'}>
          <TabPane
            tab={
              <span>
                <Icon type="info-circle" />
                Details
              </span>
            }
            key="#details">
            {!isConfirmed && (
              <Row>
                <SubmitButton />
              </Row>
            )}

            {!isFreight && <ReadyToOrderForm ref={formRef} {...props} />}
            {isFreight && <ReadyToOrderFreightForm ref={formRef} {...props} />}
          </TabPane>

          <TabPane
            tab={
              <span>
                <Icon type="ordered-list" />
                PO Lines
              </span>
            }
            key="#fee">
            <FeeCont {...{ order, isUpdatable }} />
          </TabPane>

          {isFreight && (
            <TabPane
              tab={
                <span>
                  <Icon type="ordered-list" /> Packing List
                </span>
              }
              key="#freight">
              <PackingCont order={order} />
            </TabPane>
          )}

          <TabPane
            tab={
              <span>
                <Icon type="ordered-list" /> Payment Terms
              </span>
            }
            key="#payment-terms">
            <PaymentTermsCont owner={order} isUpdatable={isUpdatable} />
          </TabPane>

          <TabPane
            tab={
              <span>
                <Icon type="ordered-list" /> Payment Plan
              </span>
            }
            key="#payment">
            <PaymentPlanCont owner={order} isUpdatable={isUpdatable} />
          </TabPane>

          <TabPane
            tab={
              <span>
                <Icon type="ordered-list" /> Vouchers
              </span>
            }
            key="#voucher">
            <VouchersCont {...{ order }} />
          </TabPane>

          <TabPane
            tab={
              <span>
                <Icon type="ordered-list" /> Remittance
              </span>
            }
            key="#remittance">
            <RemittanceList
              {...{
                list: listRemittance,
                fetching: fetchingRemittance,
                fetch: fetchRemittance,
                hideCompany: true,
                hideCreate: true,
              }}
            />
          </TabPane>

          <TabPane
            tab={
              <span>
                <Icon type="file-text" />
                Delivery Order
              </span>
            }
            key="#delivery">
            <DeliveryOrderList
              {...{
                list: listDelivery,
                fetching: fetchingDelivery,
                fetch: fetchDelivery,
                hideCompany: true,
                hideCreate: true,
              }}
            />
          </TabPane>

          <TabPane
            tab={
              <span>
                <Icon type="copy" />
                History
              </span>
            }
            key="#history">
            <History isArray={true} loading={fetching} owner={order} />
          </TabPane>
          <TabPane
            tab={
              <span>
                <Icon type="folder-open" />
                Rating
              </span>
            }
            key="#rating">
            {/*<AddRatingSystemCont owner={order._id} templateKey={'10334069150760'} />*/}
            <AddQuestionnaireSystemCont owner={order._id} templateKey={'10334069660507'} />
          </TabPane>
          <TabPane tab="Email" key="#email">
            <EmailListCont owner={order._id} />
          </TabPane>
          <TabPane
            tab={
              <span>
                <Icon type="folder-open" />
                Documents
              </span>
            }
            key="#docs">
            <Documents
              editable={true}
              footer={false}
              category={false}
              email={true}
              emailLabel={'Email w/ PO'}
              owner={order}
            />
          </TabPane>
        </Tabs>
      </Card>
    </CustomSpin>
  )
}

export default withRouter(UpdateOrder)
